module.exports = __webpack_public_path__ + "img/logo-footer.f75ce73c.svg";